import { t } from '@hefe/i18n';
import { BasketballEventFilterType, BasketballEventType } from '@hefe/models';
import { BasketballEventsSlice, userState } from '@hefe/store';
import { Checkbox, Col, Collapse, Divider, Row, Space } from 'antd';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';

export default function UserEventsFilterComponent() {
  const dispatch = useAppDispatch();
  const user = useSelector(userState).user;
  const eventState = useSelector(BasketballEventsSlice.basketballEventsState);
  const numberOfActiceFilters = useSelector(
    BasketballEventsSlice.numberOfActiveBasketballUserEventsFilters
  );

  const renderTypeFilters = () => {
    const filterCheckboxes: any[] = [];
    eventState.filters[BasketballEventFilterType.TYPES].forEach((filter) => {
      const payload = {
        id: filter,
        type: BasketballEventFilterType.TYPES,
      };
      const checked =
        eventState.activeFilters[BasketballEventFilterType.TYPES].findIndex(
          (activeFilter) => activeFilter === filter
        ) > -1;
      filterCheckboxes.push(
        <Checkbox
          key={filter}
          checked={checked}
          onChange={(e) =>
            dispatch(
              checked
                ? BasketballEventsSlice.basketballEventsActions.removeFilter(
                    payload
                  )
                : BasketballEventsSlice.basketballEventsActions.addFilter(
                    payload
                  )
            )
          }
        >
          {t(BasketballEventType[filter]?.toLowerCase())}
        </Checkbox>
      );
    });

    return <Space direction="vertical">{filterCheckboxes}</Space>;
  };

  const renderTasksFilter = () => {
    const filterCheckboxes: any[] = [];
    eventState.filters[BasketballEventFilterType.TASKS].forEach((filter) => {
      const payload = {
        id: filter.id,
        type: BasketballEventFilterType.TASKS,
      };
      const checked =
        eventState.activeFilters[BasketballEventFilterType.TASKS].findIndex(
          (activeFilter) => activeFilter === filter.id
        ) > -1;
      filterCheckboxes.push(
        <Checkbox
          key={filter.id}
          checked={checked}
          onChange={(e) =>
            dispatch(
              checked
                ? BasketballEventsSlice.basketballEventsActions.removeFilter(
                    payload
                  )
                : BasketballEventsSlice.basketballEventsActions.addFilter(
                    payload
                  )
            )
          }
        >
          {filter.name}
        </Checkbox>
      );
    });

    return <Space direction="vertical">{filterCheckboxes}</Space>;
  };

  const renderTeamsFilter = () => {
    const filterCheckboxes: any[] = [];
    const filterType: BasketballEventFilterType =
      BasketballEventFilterType.TEAMS;
    eventState.filters[filterType].forEach((team) => {
      const payload = {
        id: team.id,
        type: filterType,
      };
      const checked =
        eventState.activeFilters[filterType].findIndex(
          (activeFilter) => activeFilter === team.id
        ) > -1;
      filterCheckboxes.push(
        <Checkbox
          key={team.id}
          checked={checked}
          onChange={(e) =>
            dispatch(
              checked
                ? BasketballEventsSlice.basketballEventsActions.removeFilter(
                    payload
                  )
                : BasketballEventsSlice.basketballEventsActions.addFilter(
                    payload
                  )
            )
          }
        >
          {team.name}
        </Checkbox>
      );
    });

    return <Space direction="vertical">{filterCheckboxes}</Space>;
  };

  const renderUsersFilter = () => {
    const filterCheckboxes: any[] = [];
    const filterType: BasketballEventFilterType =
      BasketballEventFilterType.USERS;
    eventState.filters[filterType].forEach((user) => {
      const payload = {
        id: user.id,
        type: filterType,
      };
      const checked =
        eventState.activeFilters[filterType].findIndex(
          (activeFilter) => activeFilter === user.id
        ) > -1;
      filterCheckboxes.push(
        <Checkbox
          key={user.id}
          checked={checked}
          onChange={(e) =>
            dispatch(
              checked
                ? BasketballEventsSlice.basketballEventsActions.removeFilter(
                    payload
                  )
                : BasketballEventsSlice.basketballEventsActions.addFilter(
                    payload
                  )
            )
          }
        >
          {user.firstname} {user.lastname}
        </Checkbox>
      );
    });

    return <Space direction="vertical">{filterCheckboxes}</Space>;
  };

  const collapseHeader =
    numberOfActiceFilters > 0
      ? t('active_filters', { number: numberOfActiceFilters })
      : t('filter');

  return (
    <Row>
      <Col xs={24}>
        <Collapse bordered={false} ghost>
          <Collapse.Panel header={collapseHeader} key={1}>
            <Row justify="space-around">
              <Col xs={24} md={8}>
                <Divider>{t('type')}</Divider>
                {renderTypeFilters()}
              </Col>
              <Col xs={24} md={8}>
                <Divider>{t('team')}</Divider>
                {renderTeamsFilter()}
              </Col>
              {eventState.filters.tasks.length > 0 && (
                <Col xs={24} md={8}>
                  <Divider>{t('tasks.plural')}</Divider>
                  {renderTasksFilter()}
                </Col>
              )}
              {user?.user_settings.show_child_users && (
                <Col xs={24} md={8}>
                  <Divider>{t('user')}</Divider>
                  {renderUsersFilter()}
                </Col>
              )}
            </Row>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
}
